import { Phone, MapPin, MessageSquare } from "lucide-react";
import { siteConfig } from "@/lib/site-config";

/**
 * Thin bar above the navbar — full address on the left, phone on the right,
 * per the site brief. Hidden on the smallest screens where the navbar CTA
 * already exposes the phone number.
 */
const TopBar = () => {
  return (
    <div className="hidden sm:block bg-accent text-accent-foreground">
      <div className="container-max flex flex-col sm:flex-row items-center justify-between px-4 py-2 text-xs sm:text-sm gap-1 sm:gap-0">
        <div className="flex items-center gap-2 min-w-0">
          <MapPin className="h-3.5 w-3.5 text-secondary shrink-0" />
          <span className="truncate">{siteConfig.address.full}</span>
        </div>

        <div className="flex items-center gap-5 shrink-0">
          <a
            href={siteConfig.smsHref}
            className="hidden lg:flex items-center gap-2 hover:text-secondary transition-colors"
          >
            <MessageSquare className="h-3.5 w-3.5 text-secondary" />
            <span>Text {siteConfig.smsPhone}</span>
          </a>
          <a
            href={siteConfig.phoneHref}
            className="flex items-center gap-2 hover:text-secondary transition-colors font-semibold"
          >
            <Phone className="h-3.5 w-3.5 text-secondary" />
            <span>{siteConfig.phone}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
